export interface IVideoProps {
  source: string;
}
